import * as yup from 'yup';

import {
  fieldsValidation as sharedFieldsValidation,
  fieldsValidationWithRequired,
} from '@/constants/shared-validation';
import { ContactVm } from '@/types';

export const fieldsValidation = {
  anyString: sharedFieldsValidation.anyString,
  name: fieldsValidationWithRequired.name,
  companyName: sharedFieldsValidation.name,
  address: fieldsValidationWithRequired.address,
  city: fieldsValidationWithRequired.city,
  phoneNumber: fieldsValidationWithRequired.phoneNumber,
  state: fieldsValidationWithRequired.state,
  zipCode: fieldsValidationWithRequired.zipCode,
  email: fieldsValidationWithRequired.email,
};

export const validationSchema = yup.object({
  firstName: fieldsValidation.name,
  lastName: fieldsValidationWithRequired.name,
  phoneNumber: fieldsValidation.phoneNumber,
  email: fieldsValidation.email,
  addressLine1: fieldsValidationWithRequired.address,
  city: fieldsValidationWithRequired.city,
  state: fieldsValidationWithRequired.state,
  zipCode: fieldsValidationWithRequired.zipCode,
});

export const getInitialValues = (addressToEdit: ContactVm | null, isDefault: boolean) => ({
  contactId: addressToEdit?.contactId ?? '',
  firstName: addressToEdit?.firstName ?? '',
  lastName: addressToEdit?.lastName ?? '',
  phoneNumber: addressToEdit?.phoneNumber ?? '',
  email: addressToEdit?.email ?? '',
  addressLine1: addressToEdit?.addressLine1 ?? '',
  addressLine2: addressToEdit?.addressLine2 ?? '',
  city: addressToEdit?.city ?? '',
  state: addressToEdit?.state ?? '',
  zipCode: addressToEdit?.zipCode ?? '',
  eligibleEdit: addressToEdit?.eligibleEdit ?? false,
  isDefault: addressToEdit?.isDefault ?? isDefault,
  isDoNotEmail: false,
  isDoNotCall: false,
  hasOptedOutOfEmail: false,
});

export const addressFormMock = {
  contactId: 'a0175000001etNmAAI',
  firstName: 'New',
  lastName: 'llll',
  phoneNumber: '455-665-4747',
  email: 'form@com.com',
  addressLine1: '6554 Chupp Road',
  addressLine2: null,
  city: 'Lithonia',
  state: 'GA',
  zipCode: '30058',
  eligibleEdit: false,
  isDefault: true,
  isDoNotEmail: false,
  isDoNotCall: false,
  hasOptedOutOfEmail: false,
};
